function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".clock_svg__cls-1{fill:#fff}"));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "clock_svg__cls-1",
  d: "M150.29.17c-82.5 0-150 67.5-150 150s67.5 150 150 150 150-67.51 150-150-67.5-150-150-150zm107.82 208.12l-10.32-5.62-3.74 5.62 10.29 5.64a118.48 118.48 0 01-40.29 40.32l-5.64-10.31-5.62 3.74 5.62 10.32c-16.88 9.38-34.68 14.07-55.32 15v-12.19h-6.56V273c-19.68-.93-38.45-5.62-55.3-15l5.62-10.31-5.62-3.74-5.64 10.31a118.59 118.59 0 01-40.3-40.32l10.3-5.64-3.74-5.62-10.32 5.62c-9.36-16.85-14.06-34.68-15-55.3h12.2v-6.56h-12.2c.94-19.7 5.64-38.44 15-55.31l10.32 5.61 3.74-5.61-10.3-5.63a118.33 118.33 0 0140.3-40.32l5.64 10.31 5.62-3.76-5.62-10.29c16.85-9.38 34.68-14.09 55.3-15v12.18h6.56V26.44c19.7.91 38.44 5.62 55.32 15l-5.62 10.29 5.62 3.76 5.64-10.31a118.21 118.21 0 0140.29 40.32l-10.29 5.62 3.74 5.61 10.32-5.61c9.36 16.87 14.06 34.68 15 55.31H260.9V153h12.2a130.89 130.89 0 01-15 55.3zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "clock_svg__cls-1",
  d: "M150.29 56.44v93.73h93.76c0-51.56-42.2-93.73-93.76-93.73zm0 0"
});

var SvgClock = function SvgClock(props) {
  return React.createElement("svg", _extends({
    id: "clock_svg__Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 300 300"
  }, props), _ref, _ref2, _ref3);
};

export default SvgClock;